export const REACT_APP_API_URL = process.env.REACT_APP_DOMAIN == "development"
    ? window.location.protocol + "//" + window.location.hostname + ":8000/"
    : window.location.origin + "/";

// export const REACT_APP_API_URL = "http://127.0.0.1:8000";

export const CONTANT_TYPE = "application/json";

export const CONTACT_API_ROUTE = "contact";

export const CAREER_API_ROUTE = "career";

export const QUOTE_API_ROUTE = "quote";